
<template>
    <div :id="id" v-loading="loading" class="vegaContain" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>


<script>
import * as vega from "vega";
import ESGData from "./ESGData.json"
import apiAxios from "@/config/apiAxios";
export default {
    name: "ESG",
    props: {
        id: {
            type: String,
            required: true,
            default: "",
        },
    },
    components: {

    },

    data() {
        return {
            vegaView: {},
            loading: true,
            vegaDefaultConfig: {
                $schema: "https://vega.github.io/schema/vega/v5.json",
                padding: 0,
                autosize: "fit",
                title: {
                    color: "#fff", subtitleColor: "#fff",
                    text: "2022年ESG主题", anchor: "middle",
                    fontSize: 16,
                    frame: "group",
                    offset: 4,
                },
                config: {
                    locale: {
                        time: {
                            periods: ["上午", "下午"],
                            days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                            shortDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                            months: [
                                "1月",
                                "2月",
                                "3月",
                                "4月",
                                "5月",
                                "6月",
                                "7月",
                                "8月",
                                "9月",
                                "10月",
                                "11月",
                                "12月",
                            ],
                            shortMonths: [
                                "1月",
                                "2月",
                                "3月",
                                "4月",
                                "5月",
                                "6月",
                                "7月",
                                "8月",
                                "9月",
                                "10月",
                                "11月",
                                "12月",
                            ],
                        },
                    },
                },

                "signals": [
                    {
                        "name": "width",
                        "update": "containerSize()[0]",
                        "on": [
                            {
                                "events": { "source": "window", "type": "resize" },
                                "update": "containerSize()[0]"
                            }
                        ]
                    },
                    {
                        "name": "height",
                        "update": "containerSize()[1]",
                        "on": [
                            {
                                "events": { "source": "window", "type": "resize" },
                                "update": "containerSize()[1]"
                            }
                        ]
                    },
                    {
                        "name": "year",
                        "description": "年份",
                        "value": 2022

                    },
                    {
                        "name": "minTime",
                        "value": "time(datetime((year+1),0,1,0,0,0))",
                        "update": "time(datetime((year+1),0,1,0,0,0))"
                    },
                    {
                        "name": "maxTime",
                        "value": "time(datetime((year+1),11,31,59,59,59))",
                        "update": "time(datetime((year+1),11,31,59,59,59))"
                    }
                ],
                "data": [
                    {
                        "name": "table",
                        "values": ESGData,
                        "transform": [
                            {
                                "type": "project",
                                "fields": [
                                    "eid",
                                    "GE8000090E",
                                    "GE8000087E",
                                    "GE8000088E",
                                    "GE8000089E"
                                ],
                                "as": ["eid", "board", "eventType", "eventName", "eventTime"]
                            },
                            { "type": "formula", "expr": "time(datum.eventTime)", "as": "eventTime" },
                            { "type": "collect", "sort": { "field": "GE8000089E" } }
                        ]
                    },
                    {
                        "name": "ESGData",
                        "source": "table",
                        "transform": [
                            { "type": "filter", "expr": "datum.eventTime<=maxTime" },
                            { "type": "filter", "expr": "datum.eventTime>=minTime" },
                            {
                                "type": "aggregate",
                                "groupby": ["board"],
                                "fields": ["eventName", "eventName"],
                                "ops": ["values", "count"],
                                "as": ["events", "count"]
                            },
                            {
                                "type": "pie",
                                "field": "count"
                            }
                        ]
                    },
                    {
                        "name": "allcount",
                        "source": "ESGData",
                        "transform": [
                            {
                                "type": "aggregate",
                                "fields": ["count"],
                                "ops": ["sum"],
                                "as": ["allcount"]
                            }
                        ]
                    }
                ],
                "scales": [
                    { "name": "color", "type": "ordinal", "range": { "scheme": "category20" } }
                ],
                "marks": [
                    {
                        "type": "arc",
                        "from": { "data": "ESGData" },
                        "encode": {
                            "enter": {
                                "fill": { "scale": "color", "field": "board" },
                                "x": { "signal": "width / 2" },
                                "y": { "signal": "height /2" }
                            },
                            "update": {
                                "startAngle": { "field": "startAngle" },
                                "endAngle": { "field": "endAngle" },
                                "innerRadius": { "value": 0 },
                                "outerRadius": { "signal": "height / 3" },
                                "tooltip": { "signal": "year+'年，'+datum.board+'已披露'+datum.count+'份'" }
                            }
                        }
                    }
                ]
            }
        }
    },
    methods: {
        vegaInit() {
            let width = document.getElementById(this.id).clientWidth;
            let height = document.getElementById(this.id).clientHeight;
            this.vegaDefaultConfig.width = width;
            this.vegaDefaultConfig.height = height;
            let aa = vega.parse(this.vegaDefaultConfig);
            var view = new vega.View(vega.parse(this.vegaDefaultConfig))
                .renderer("svg")
                .initialize("#" + this.id)
                .hover()
                .run();
            let that = this;
            view.addEventListener("click", function (event, item) {
                let datanum = item.datum.datum || item.datum;
                that.showTpl(datanum);

            });
            view.addEventListener("touchstart", function (event, item) {
                let datanum = item.datum.datum || item.datum;
                that.showTpl(datanum);

            });
            this.loading = false;
            this.vegaView = view;
        },
        showTpl(item) {

            let params = { tags: ["genesys.GM00014088"] };
            let loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            apiAxios.apmSyncPost("api000161", params, {}, (_res) => {
                loading.close();
                if (_res.code == 200) {
                    let _data = _res.data;
                    let datas_obj = {};

                    datas_obj.cat_sys_chapter = {
                        extends: {
                            resource: {
                                path: _data.cat_chapter,
                            },
                        },
                    };
                    datas_obj.cat_sys_html = {
                        extends: {
                            resource: {
                                path: _data.cat_html,
                            },
                        },
                    };
                    datas_obj.ctx_sys_json = {
                        extends: {
                            resource: {
                                path: _data.ctx_tpl,
                            },
                        },
                    };
                    datas_obj.meta_element = {
                        extends: {
                            resource: {
                                path: _data.meta_element,
                            },
                        },
                    };
                    let ld = _data.ld;

                    let _params = {
                        datas_obj: datas_obj,
                        type: "tpl",
                        readerLabel: "数据热力图",
                        dialogtitle: item.board,
                        ld: ld,
                    };
                    this.$EventBus.$emit("opendialogCmdpReader", { _params: _params });
                } else {
                    this.$notify({
                        type: "warn",
                        message: "暂无数据",
                    });
                }
            });
        },
    },
    mounted() {
        this.vegaInit();
    }

}

</script>

<style></style>